import React, { useState, useEffect } from 'react';
import {useNavigate, useParams } from 'react-router-dom';
import {ModalHeader, Modal, ModalBody } from "reactstrap";
import Top from '../Top';
import Leftsiderbar from '../home/allcmp/Leftsidebar'
import { API_URL } from '../../../config';
import right from '../../images/right.png'
import { json } from 'd3';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';


const UploadRecording = () => {
 

  const [uploadingHeadline, setUploadingHeadline] = useState('')
  const [downloaderModal, setDownloaderModal] = useState(false);
    const DownloaderToggleModal = () => setDownloaderModal(!downloaderModal);
  const [softwareLink, setSoftwareLink] = useState('');
  const [software, setSoftware] = useState('');
  const [upcomingSoftware, setUpcomingSoftware] = useState('');
  const [updateSoftware, setUpdateSoftware] = useState('');
  const [uploadContent, setUploadContent] = useState('');
  const [ softwareSource, setSoftwareSource] = useState();
  const [osType,setOsType] = useState('');
  const [successModal, setsuccessModal] = useState(false);
  const successToggleModal = () => setsuccessModal(!successModal);
  const { id } = useParams();
  const [editData, setEditData] = useState(['']);
  const [linkErr, setLinkErr] = useState(false);
  const [show, setShow] = useState(true)

  const [uploadingHeadlineErr, setUploadingHeadlineErr] = useState(false)
  const [updateSoftwareErr, setUpdateSoftwareErr] = useState(false);
  const [uploadContentErr, setUploadContentErr] = useState(false);
  const [ softwareSourceErr, setSoftwareSourceErr] = useState(false);
  const [osTypeErr,setOsTypeErr] = useState(false);
  const [softwareLinkErr, setSoftwareLinkErr] = useState(false);
  const [softwareErr, setSoftwareErr] = useState(false);
  const [errMessage,setErrMessage] = useState('')
  const navigate = useNavigate()
  const [statusFieldErr, setStatusFieldErr] = useState(false);
  const [statusField, setStatusField] = useState('')
  
  useEffect(() => {
    if(id){
      getEditData();
    }

  }, [])

  const getEditData = () => {
    fetch(API_URL + "/get/software/data/by/" + id,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    ).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setEditData(resp.data);
          if(id){
            setUploadingHeadline(resp.data[0].headline);
            setUploadContent(resp.data[0].content)
            setSoftwareSource(resp.data[0].sw_type)
            setStatusField(resp.data[0].status)
            if(resp.data[0].sw_type == 1){
            setSoftwareLink(resp.data[0].software_exe)
            }else if(resp.data[0].sw_type == 2){
              setSoftware(resp.data[0].software_exe)
              setUpcomingSoftware(resp.data[0].software_exe)
            }
            setOsType(resp.data[0].os_type)
            
          }

        });
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }

 

  const handleSoftwareSource = (e) => {
   setSoftwareSource(e.target.value);

  }

  const handleOsType =(e)=>{
   setOsType(e.target.value)
  }


  const createProfile = () => {
    if(isValidCreate()){
      if(softwareSource==1){
        rowData();
      }else if(softwareSource==2){
        formData()
      }
    }else{
      return false
    }


  }

  const handleGoBack = () => {
    if(id){
      navigate('/edit-software');
    }else{
    navigate('/software-update');

    }
  }
  // const isLinkValidForOS = (link)=> {
  //   var extension = link.substr(link.lastIndexOf('.') + 1);
  //   var userAgent = window.navigator.userAgent;
    
  //   if (/Macintosh/.test(userAgent) || (extension === 'dmg' || extension === 'zip') && osType == 2) {
  //     return true;
  //   } else if (/Windows/.test(userAgent) || extension === 'exe' && osType == 1) {
  //     return true;
  //   }
    
  //   return false;
  // } check link for window and mac

  function checkLinkForExeOrDmg(link) {
    return true;
    if(osType == 1){
      var downloadRegex = /\.exe$/i;
      return downloadRegex.test(link)
      // return link.includes('.exe') 
    }else if(osType == 2){
      var downloadRegex = /\.dmg$/i;

      return downloadRegex.test(link)
  }else{
    return false;
  }
  }
  function isWindowsFile(filename) {
    if (typeof filename == 'string') {
      return false;
    }
  
    const windowsExtensions = ['exe'];
  
    const fileExtension = filename.name.split('.').pop().toLowerCase();
    
    return windowsExtensions.includes(fileExtension);
  }
  function isMacFile(filename) {
    return true
    // if (typeof filename == 'string') {
    //   return false;
    // }
  
    // const windowsExtensions = ['dmg'];
  
    // const fileExtension = filename.name.split('.').pop().toLowerCase();
    
    // return windowsExtensions.includes(fileExtension);
  }

 
  
  
const isValidCreate = () =>{
  if(uploadingHeadline == "" &&  osType == '0'&& softwareSource == "0" && uploadContent == "" && updateSoftware == "") {
    setErrMessage("All field required")
  }else if(uploadingHeadline.trim() == ""){
    setUploadingHeadlineErr(true);
    setLinkErr(false)
    setUploadContentErr(false);
    setSoftwareSourceErr(false);
    setOsTypeErr(false);
    setUpdateSoftwareErr(false);
    setErrMessage("Field required")
    return false;
  }else if(uploadContent.trim() == ""){
    setUploadContentErr(true);
    setLinkErr(false)
    setSoftwareSourceErr(false);
    setOsTypeErr(false);
    setUpdateSoftwareErr(false);
    setUploadingHeadlineErr(false);
    setErrMessage("Field required")
    return false;
  }else if(!softwareSource){
    setSoftwareSourceErr(true);
    setLinkErr(false)
    setOsTypeErr(false);
    setUpdateSoftwareErr(false);
    setUploadingHeadlineErr(false);
    setUploadContentErr(false);
    setErrMessage("Field required")
    return false;
  }else if(!osType){
    setOsTypeErr(true);
    setLinkErr(false)
    setUpdateSoftwareErr(false);
    setUploadingHeadlineErr(false);
    setUploadContentErr(false);
    setSoftwareSourceErr(false);
    setErrMessage("Field required")
    return false;
  }
  else if(softwareSource == "1"){
    if(checkLinkForExeOrDmg(softwareLink)){
      setSoftwareSourceErr(false);
      setLinkErr(false)
      setOsTypeErr(false);
      setUpdateSoftwareErr(false);
      setUploadingHeadlineErr(false);
      setUploadContentErr(false);
      return true;
    }else if(id && statusField == ''){
      setSoftwareLinkErr(false)
      setSoftwareSourceErr(false);
      setLinkErr(false)
      setOsTypeErr(false);
      setUpdateSoftwareErr(false);
      setUploadingHeadlineErr(false);
      setUploadContentErr(false);
      setStatusFieldErr(true);
      setErrMessage("Field required")
    }
    else{
      setSoftwareLinkErr(true)
      setSoftwareSourceErr(false);
      setLinkErr(false)
      setOsTypeErr(false);
      setUpdateSoftwareErr(false);
      setUploadingHeadlineErr(false);
      setUploadContentErr(false);
      setErrMessage("Enter valid link")
      return false
    }
  }
  else if(softwareSource == "2"){
    if(software.length ==0){
      setSoftwareErr(true);
      setSoftwareSourceErr(false);
      setLinkErr(false)
      setOsTypeErr(false);
      setUpdateSoftwareErr(false);
      setUploadingHeadlineErr(false);
      setUploadContentErr(false);
      setErrMessage("Field required")
      return false;
    }
    else if(software.length !=0 && osType == 1){
      if(isWindowsFile(software)){
        return true
      }else{
        setSoftwareErr(true);
        setSoftwareSourceErr(false);
        setLinkErr(false)
        setOsTypeErr(false);
        setUpdateSoftwareErr(false);
        setUploadingHeadlineErr(false);
        setUploadContentErr(false);
        setErrMessage("Enter valid file")
        return false;
      }
    }else if(software.length !=0 && osType == 2){
      if(isMacFile(software)){
        return true
      }else{
        setSoftwareErr(true);
        setSoftwareSourceErr(false);
        setLinkErr(false)
        setOsTypeErr(false);
        setUpdateSoftwareErr(false);
        setUploadingHeadlineErr(false);
        setUploadContentErr(false);
        setErrMessage("Enter valid file")
        return false;
      }
    }
    else if(software.length !=0 && osType == 3){
      if(isMacFile(software)){
        return true
      }else{
        setSoftwareErr(true);
        setSoftwareSourceErr(false);
        setLinkErr(false)
        setOsTypeErr(false);
        setUpdateSoftwareErr(false);
        setUploadingHeadlineErr(false);
        setUploadContentErr(false);
        setErrMessage("Enter valid file")
        return false;
      }
    }
  }else{
    return true
  }
  return true
}
  const handleUpdate = ()=>{
      if(isValidCreate()){
      if(softwareSource==1){
        UpadateRowData()
      }else if(softwareSource==2){
        if(software == upcomingSoftware){
          UpadateRowData()
        }else{
      UpdateFormData()
        } 
      }
      }else{
        return false
      }
  }
  const rowData = () =>{
    setDownloaderModal(true)
    let data = {};
    data['headline'] = uploadingHeadline;
    data['content'] = uploadContent;
    data['sw_type'] = softwareSource;
    data['os_type'] = osType;
    data['software_exe'] = softwareLink;
    fetch(API_URL + "/create/software/data", {
      method: 'POST',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)

    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setDownloaderModal(false)
          successToggleModal();
          setTimeout(function(){navigate('/edit-software') }, 5000);
 

        });

      }
      else if (response.status == 400) {
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }
  const formData = () =>{
    setDownloaderModal(true)
    const formData = new FormData();
    formData.append('headline', uploadingHeadline);
    formData.append('content', uploadContent);
    formData.append('sw_type', softwareSource);
    formData.append('os_type', osType);
    formData.append('form',software);
    fetch(API_URL + "/create/software/data", {
      method: 'POST',
      body: formData

    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setLoader(false)
          setDownloaderModal(false)
          successToggleModal();
          setTimeout(function(){navigate('/edit-software') }, 5000);
 

        });

      }
      else if (response.status == 400) {
        setLoader(false)
      }
      else if (response.status == 401) {
        setLoader(false)
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }
  const UpdateFormData = () =>{
    setDownloaderModal(true)
    const formData = new FormData();
    formData.append('headline', uploadingHeadline);
    formData.append('content', uploadContent);
    formData.append('sw_type', softwareSource);
    formData.append('os_type', osType);
    formData.append('form',software);
    formData.append('status', statusField);
    fetch(API_URL + "/update/software/data/by/" + id, {
      method: 'PUT',
      body: formData

    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setDownloaderModal(false)
          successToggleModal();
          setTimeout(function(){navigate('/edit-software') }, 5000);
 

        });

      }
      else if (response.status == 400) {
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }
  const UpadateRowData = () =>{
    setDownloaderModal(true)
    let data = {};
    data['headline'] = uploadingHeadline;
    data['content'] = uploadContent;
    data['sw_type'] = softwareSource;
    data['os_type'] = osType;
    if(software == upcomingSoftware && softwareSource == 2){
      data['software_exe'] = software;

    }else{
      data['software_exe'] = softwareLink;
    }
    data['status'] = statusField;
    fetch(API_URL + "/update/software/data/by/" + id, {
      method: 'PUT',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data)

    }).then((response) => {
      if (response.status == 200) {
        response.json().then((resp) => {
          setDownloaderModal(false)
          successToggleModal();
          setTimeout(function(){navigate('/edit-software') }, 5000);
 

        });

      }
      else if (response.status == 400) {
      }
      else if (response.status == 401) {
        logout()
      }
      else {
        console.log("network error")
      }


    })
  }
  const handleLinkChange = (event)=>{
    setSoftwareLink(event.target.value)
    setSoftwareLinkErr(false)
  }
  const handleCloseLink = () =>{
    // setUpcomingSoftware('');
    setSoftware('')
    setShow(false)
  }

  return (
    <div>
      <div className="cmail">
        <Top />
      </div>
      <div className="wrp-dashbord">
        <div className="cemail-left">
          <Leftsiderbar />
        </div>

        
        <div className="right-section ">
        <div className="head-listing head-listingb">
                            <h3>{id ? "Edit Software":"Upload New Software"}</h3>
                        </div>
     
          <div className='right-section-box'>

            {/* =============1==== */}
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>Update Headline* </label>
                  <input type="text" value={uploadingHeadline}  onChange={(e) => setUploadingHeadline(e.target.value)} className='client-input' placeholder='Enter headline' />
              {uploadingHeadlineErr ? <div className='linkError'>{errMessage}</div>:""}

                </div>
              </div>

            </div>
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>
                  Update Content*</label>
                  <textarea type="textarea" rows='1' cols='52' name='address' value={uploadContent} onChange={(e) => setUploadContent(e.target.value)}style={{height:'250px'}} className='client-input' />
                  {uploadContentErr ? <div className='linkError'>{errMessage}</div>:""}
                  </div>
              </div>
            </div>

            {/* =======4==== */}
            <div className='col-lg-12'>
              <div className='row'>

                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>
                  
                OS Type*</label>
                <select value={osType} onChange={(e)=>setOsType(e.target.value)} className='client-input' placeholder='Choose Country'>
                    <option value="">Select Software Type</option>
                    <option value="1"  selected= {osType == 1 ? "selected" : ''}>Window</option>
                    <option value="2" selected= {osType == 2 ? "selected" : ''} >Mac (x86)</option>
                    <option value="3" selected= {osType == 3 ? "selected" : ''} >Mac (arm64)</option>
                  </select>
                  {/* <select onChange={handleOsType} defaultValue={id ? editData[0].os_type:''} className='client-input' placeholder='Choose Country'>
                    <option value="">Select Type</option>
                    <option value="1" selected={1 ? editData[0].os_type:''}>Window</option>
                    <option value="2" selected={1 ? editData[0].os_type:''}>Mac</option>

                  </select> */}
                  </div>
                  {osTypeErr ? <div className='linkError'>{errMessage}</div>:""}

              </div>
            </div>

            <div className='col-lg-12'>
              <div className='row'>

                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>
                  Software Source*</label>
                  <select value={softwareSource} onChange={(e)=>setSoftwareSource(e.target.value)} className='client-input' placeholder='Choose Country'>
                    <option value="">Select Software Type</option>
                    <option value="1" >Link</option>
                    <option value="2" >File</option>
                  </select>
                 </div>
                  {softwareSourceErr ? <div className='linkError'>{errMessage}</div>:""}

                  {/* ========================working=============== */}
                 {softwareSource == 1 ? <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>Software Link* </label>
                  <input type="text" value={softwareLink}  onChange={handleLinkChange} className='client-input' placeholder={osType== 1 ?'https://example.com/download/file.exe': 'https://example.com/download/file.dmg'} />
                  {softwareLinkErr ? <div className='linkError'>{errMessage}</div>:""}
                </div>
              </div>
            </div> :''}
            {/* =============File============= */}
            {softwareSource == 2 ? <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>Software*</label>
                  <input type="file"   onChange={(e) => {setSoftware(e.target.files[0]); setSoftwareErr(false)}} className='client-input' placeholder='Enter headline' />
                  {softwareErr ? <div className='linkError'>{errMessage}</div>:""}
                  {id && softwareSource == 2 &&  show && software.length!=0 && upcomingSoftware.length!=0?<>
                  {/* <label className=' control-label'>Software File :</label> */}
                  {/* <a href={upcomingSoftware}  className='view-recording'> {upcomingSoftware}</a><HighlightOffIcon style={{color:'blue', marginLeft:'5px'}} onClick={handleCloseLink}/> */}
                  
                  { 
                    id && show ? <div style={{display:'flex',marginTop: "20px"}}><label className='control-label'>Software link : </label><p  className='view-recording' target="_blank" onClick={()=>handleButtonClick(upcomingSoftware)}>{upcomingSoftware}</p><HighlightOffIcon style={{color:'blue', marginLeft:'5px', cursor:'pointer'}} onClick={handleCloseLink}/></div>: ""
                    
                  }
                  </>:''} 
                </div>
              </div>
            </div> : ''}
            {id ? <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>
                  Status*</label>
                  <select value={statusField} onChange={(e)=>setStatusField(e.target.value)} className='client-input' placeholder='Choose Country'>
                    <option value="">Select Status</option>
                    <option value="1" selected={statusField == 1 ? "Selected": ''}>Active</option>
                    <option value="0" selected={statusField == 0 ? "Selected": ''}>Inactive</option>
                  </select>
                  {statusFieldErr ? <div className='linkError'>{errMessage}</div>:""}
                 </div>:''}
            {/* ====================working==================== */}

              </div>
            </div>
           
           {/* {id ? <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-12 no-padding'>
                  <label className=' control-label'>Update Software* </label>
                  <input type="text" value={updateSoftware}  onChange={(e) => setUpdateSoftware(e.target.value)} className='client-input' placeholder='Enter headline' />
              {linkErr ? <div className='linkError'>Enter valid link</div>:""}


                </div>
              </div>

            </div> : ''} */}

            {/* ======5====== */}
            <div className='col-lg-12'>
              <div className='row'>
                <div className='form-group col-lg-6 no-padding'>
                  <button type="button" className='btn btn-primary_d' onClick={handleGoBack}>Go Back</button>
                </div>
                <div className='form-group col-lg-6 no-padding'>
                 {id ? 
                 <button type="submit" className='btn btn-primary_d' onClick={handleUpdate}>Update
               </button>
                 : <button type="submit" className='btn btn-primary_d' onClick={createProfile}>Create
                  </button>}
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <Modal isOpen={downloaderModal} toggle={DownloaderToggleModal} className="connect-box" centered={true}>
                            <ModalHeader toggle={DownloaderToggleModal}><span className="ml-1 roititle font-weight-bold">Request processing...</span></ModalHeader>
                            <ModalBody>
                            <div className="modal-p">
                                <p className='text-center'>Please wait...</p>
                                <div v-if="loading" className="spinner">
        <div className="rect1"></div>
        <div className="rect2"></div>
        <div className="rect3"></div>
        <div className="rect4"></div>
        <div className="rect5"></div>
      </div>
      </div>
                            </ModalBody>

                        </Modal>
      <Modal isOpen={successModal} toggle={successToggleModal} className="connect-box" centered={true}>
        <ModalHeader toggle={successToggleModal}><span className="ml-1 roititle font-weight-bold">Successfull</span></ModalHeader>
        <ModalBody>
          <div className="modal-p">
            <div className="right-circle"><img src={right} /></div>
            <h4>{id?"Updated":"Created"}</h4>
            <p>Software has been {id?"Updated":"Created"} successfully</p>
          </div>
        </ModalBody>

      </Modal>
    </div>
  );
};

export default UploadRecording;
  
